// ==============================|| OVERRIDES - LIST ITEM ICON ||============================== //

export default function ListItemButton(theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          marginInline: 8,
          '&.Mui-selected': {
            color: theme.vars.palette.primary.main,
            backgroundColor: theme.vars.palette.action.selected,
            '& .MuiListItemIcon-root': {
              color: theme.vars.palette.primary.main
            },
            '&:hover': {
              backgroundColor: theme.vars.palette.action.selected
            }
          }
        }
      }
    }
  };
}
